import { AbstractCockpitError } from '@shared/common/error/domain/error/abstract-cockpit.error';

export const NETWORK_COCKPIT_ERROR_NAME = 'NetworkCockpitError';

export class NetworkCockpitError extends AbstractCockpitError {
  public constructor(userMessage: string, cause: unknown) {
    super('Cockpit API network request failed.', undefined, userMessage, { cause });
    this.name = NETWORK_COCKPIT_ERROR_NAME;
  }
}
